export default __webpack_public_path__ + "3fcd320612e3d14ca035a0a30089b339.jpg";